<template>
  <section class="serviceInfo">
    <p id="header">Согласно постановлениям №549 от 21.07.2008 и №410 от 14.05.2013 <br> Основанием для отказа от заключения договора (на поставку газа) является <span id="red"> отсутствие у заявителя договора о техническом обслуживании и ремонте </span> внутридомового и (или) внутриквартирного газового оборудования.</p>
    <h2>Сервисная служба ООО "ОБЛГАЗСЕРВИС-СЕВЕР"</h2>
    <p style="text-align: center">
      <img src="../img/boiler-room.webp" alt="котельная">
    </p>
    <ul>
      <li>Аттестована Ростехнадзором, допущена к монтажу, наладке и ремонту газового оборудования, проведению наладочных работ на газовом оборудовании с правом проведения газоопасных работ.</li>
      <li>Имеет в своём составе круглосуточную аварийнодиспетческую службу.</li>
      <li>Зарегистрирована в жилищной инспекции Московской области за №57.</li>
      <li>Имеет договоры на аварийнодиспетчерское обслуживание (АДО) со всеми филиалами МосОблГаза.</li>
      <li>Выполняет любые виды сервисных, пусконаладочных и ремонтных работ отопительного оборудования и систем отопления.</li>
    </ul>
    <h2>ООО "ОБЛГАЗСЕРВИС-СЕВЕР" является авторизованным сервисным центром "VIESSMANN", "VAILLANT" (PROTHERM), "SIME".</h2>
    <p id="certificateVIESSMANN">
      <img src="../img/certificate.webp" alt="">
    </p>
    <app-line>
      <p class="image">
        <img src="../img/garancy.webp" alt="">
      </p>
      <template v-slot:map>
        <h1>Гарантийные обязательства VIESSMANN</h1>
      </template>
    </app-line>
    <app-line>
      <p class="image">
        <img src="../img/serviceVITOPLEX.webp" alt="">
      </p>
      <template v-slot:map>
        <h1>Карта ТО ВИТОРОНД</h1>
      </template>
    </app-line>
    <app-line>
      <p class="image">
        <img src="../img/serviceVITOCROSSALL.webp" alt="">
      </p>
      <template v-slot:map>
        <h1>Карта ТО ВИТОКРОССАЛ</h1>
      </template>
    </app-line>
    <app-line>
      <p class="image">
        <img src="../img/serviceVITODENS.webp" alt="">
      </p>
      <template v-slot:map>
        <h1>Карта ТО ВИТОДЕНС</h1>
      </template>
    </app-line>
    <app-line>
      <p class="image">
        <img src="../img/serviceVITOGAS.webp" alt="">
      </p>
      <template v-slot:map>
        <h1>Карта ТО ВИТОГАЗ</h1>
      </template>
    </app-line>
    <app-line>
      <p class="image">
        <img src="../img/serviceVITOPEND.webp" alt="">
      </p>
      <template v-slot:map>
        <h1>Карта ТО ВИТОПЕНД</h1>
      </template>
    </app-line>
  </section>
</template>

<script>
import AppLine from "@/components/AppLine";

export default {
  components: {AppLine}
}
</script>

<style scoped>

.serviceInfo {
  display: flex;
  flex-direction: column;
  align-items: center;
}
#red {
  color: red;
  font-weight: 800;
  font-size: 1.2em;
}

h2 {
  font-family: 'Roboto', sans-serif !important;
  margin-left: 10%;
  margin-right: 10%;
}

h1 {
  color: white;
  font-weight: 800;
  text-align: left;
  padding-left: 20px;
  font-family: "Poppins", sans-serif !important;
}

.wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
}

#header {
  text-align: center;
  padding: 30px;
  font-size: 2em;
  border-bottom: 3px solid #111111;
}

ul {
  margin-left: 15%;
  margin-right: 15%;
}

ul li {
  margin: 10px;
  font-size: 2em;
}

h2  {
  text-align: center;
  color: green;
  font-weight: 800;
  padding-bottom: 20px;
  font-size: 2em;
}


img {
  width: 80%;
  height: auto;
}

.image {
  text-align: center;
  width: 100%;
}

#certificateVIESSMANN {
  text-align: center;
  width: 50%;
}

@media (max-width: 1400px) {
  ul {
    margin: 5%;
  }

  ul li {
    font-size: 1.5em;
  }

  h1 {
    font-size: 1.5em;
  }

  img {
    width: 100%;
  }

  #certificateVIESSMANN {
    width: 60%;
  }

}

@media (max-width: 767px) {
   h2 {
    font-size: 1.5em;
  }

  h1, ul li {
    font-size: 1em;
  }

  #header {
    font-size: 1.2em;
  }

  #certificateVIESSMANN {
    width: 100%;
  }
}

@media (min-width: 1600px) {
  img {
    width: 70%;
  }
}
</style>